/**
 * Liens obfusqués <me-link data-link="base64"> (prescription SEO Digimood).
 * Rendu par snippets/me-obf-link.liquid / me-obf-html.liquid.
 *
 * - Délégation sur document (survit aux morphs / re-renders SRA, un seul
 *   listener quel que soit le nombre de liens).
 * - Le custom element pose role="link" + tabindex="0" à l'upgrade : sans JS,
 *   l'élément reste un texte inerte NON focusable (pas de faux lien mort).
 * - Cmd/Ctrl+clic et clic-molette → nouvel onglet ; Entrée/Espace → navigation.
 * - data-t="1" force le nouvel onglet (réseaux sociaux).
 */
(function () {
  'use strict';

  var SELECTOR = 'me-link[data-link]';

  function urlOf(el) {
    try {
      return window.atob(el.getAttribute('data-link'));
    } catch (e) {
      return null;
    }
  }

  function go(el, newTab) {
    var url = urlOf(el);
    if (!url) return;
    if (newTab || el.getAttribute('data-t') === '1') {
      window.open(url, '_blank', 'noopener');
    } else {
      window.location.href = url;
    }
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (el) go(el, e.metaKey || e.ctrlKey);
  });

  document.addEventListener('auxclick', function (e) {
    if (e.button !== 1) return;
    var el = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (el) {
      e.preventDefault();
      go(el, true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (el) {
      e.preventDefault();
      go(el, e.metaKey || e.ctrlKey);
    }
  });

  if (window.customElements && !window.customElements.get('me-link')) {
    window.customElements.define(
      'me-link',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.hasAttribute('role')) this.setAttribute('role', 'link');
          if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
        }
      }
    );
  }
})();
